import { gql } from '@apollo/client';

export const ADD_INSTITUTIONS_TO_SERVICE_PROVIDERS = gql`
  mutation addInstitutionsToServiceProviders($inputs: [AddInstitutionsToServiceProviderInput!]!) {
    serviceProvider: addInstitutionsToServiceProviders(inputs: $inputs) {
      id
    }
  }
`;
